<template>
  <div>
    <h3>Approved Workloads</h3>

    <b-form inline @submit.prevent="" class="mb-2">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input v-model="filters.search" @input="searchItems" placeholder="Type to Search"></b-form-input>
        <b-input-group-append>
          <b-button @click="clearFilter()">Clear</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-form-select v-model="filters.timePeriodId" :options="timePeriods" value-field="timePeriodId"
        text-field="description" @input="filterItems" class="mb-2 mx-2"></b-form-select>

      <b-form-checkbox class="mx-2 mb-2" v-model="filters.undercapacityOnly" @input="filterItems">Only Show Undercapacity
        Workloads</b-form-checkbox>
      <b-form-checkbox class="mx-2 mb-2" v-model="filters.discrepanciesOnly" @input="filterItems">Only Show Workloads w/
        Discrepancies</b-form-checkbox>
    </b-form>

    <div class="ml-2 mb-2">
      <b-row>
        <b-col sm="3">
          <b-form-checkbox-group v-model="filters.paygroups" :options="paygroupOptions" @input="filterItems">
          </b-form-checkbox-group>
        </b-col>
        <b-col sm="9">
          <b-form-checkbox-group v-model="filters.tenureStatuses" :options="tenureStatusOptions" @input="filterItems">
          </b-form-checkbox-group>
        </b-col>
      </b-row>
    </div>

    <div class="ml-2 mb-2">
      <div>
        <font-awesome-icon icon="exclamation-circle" class="text-danger" v-b-tooltip.hover
          title="Number of planned courses is different than number of scheduled courses."></font-awesome-icon>
        Number of planned courses is different than number of scheduled courses.
      </div>
      <div>
        <font-awesome-icon icon="exclamation-triangle" class="text-danger" v-b-tooltip.hover
          title="This workload differs from previously approved workloads."></font-awesome-icon>
        This workload differs from previously approved workloads.
      </div>
    </div>

    <workload-list :workloads="approvedWorkloads" :workloadTypeDefinitions="workloadTypeDefinitions" :meta="meta"
      :onlyShowUndercapacity="filters.undercapacityOnly" :onlyShowDiscrepancies="filters.discrepanciesOnly"
      :showDiffersCol="isDegreeCoordinator" :showDiscrepancyCol="true" @sort="changeSort"
      @page="changePage"></workload-list>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import WorkloadList from "../../components/workloads/workload-list";
import roleChecks from "../../misc/role-checks";
import workloadApi from "../../api/workloads";
import debounce from "lodash/debounce";

export default {
  mixins: [roleChecks],

  data() {
    return {
      filters: {
        timePeriodId: null,
        undercapacityOnly: false,
        discrepanciesOnly: false,
        statuses: [],
        search: "",
        paygroups: [],
        tenureStatuses: []
      },

      approvedWorkloads: [],

      meta: {
        pageNumber: 1,
        pageSize: 20,
        totalRows: 0,
        sortBy: "asuriteId",
        sortDesc: false
      },

      statusOptions: [
        { text: "Submitted", value: "Submitted" },
        { text: "Resubmitted", value: "Resubmitted" },
        { text: "Revision", value: "Revision" }
      ],
      paygroupOptions: [
        { text: "Academic Year", value: "A12,ACD" }, // { items: ["A12", "ACD"] } },
        { text: "Fiscal Year", value: "FSW,SAL" } // { items: ["FSW", "SAL"] } },
      ],

      tenureStatusOptions: [
        { text: "Tenure-Track", value: "TRK" },
        { text: "Tenure", value: "TEN" },
        { text: "Not on Track", value: "NTR" }
      ]
    };
  },

  components: {
    "workload-list": WorkloadList
  },

  computed: {
    ...mapState({
      timePeriods: state => state.timePeriods.timePeriods,
      fiscalYearTimePeriod: state => state.status.fiscalYearTimePeriod,
      workloadTypeDefinitions: state => state.workloads.workloadTypeDefinitions
    })
  },

  methods: {
    ...mapActions("workloads", ["getWorkloadTypeDefinitions"]),

    ...mapActions("timePeriods", ["getTimePeriods"]),

    ...mapActions("status", ["getFiscalYearTimePeriod"]),

    changeSort(context) {
      this.meta.sortBy = context.sortBy;
      this.meta.sortDesc = context.sortDesc;
      this.updateWorkloads();
    },
    changePage(page) {
      this.meta.currentPage = page;
      this.updateWorkloads();
    },
    filterItems() {
      this.meta.currentPage = 1;
      this.approvedWorkloads = [];
      this.updateWorkloads();
    },

    searchItems: debounce(function () {
      this.filterItems();
    }, 500),

    updateWorkloads() {
      workloadApi
        .getApprovedWorkloads(
          this.filters,
          this.meta.currentPage,
          this.meta.perPage,
          this.meta.sortBy,
          this.meta.sortDesc
          // this.selectedTimePeriodId
        )
        .then(response => {
          this.approvedWorkloads = response.data;
          this.meta.totalRows = JSON.parse(
            response.headers["x-pagination"]
          ).TotalItems;
        });
    },

    clearFilter: function () {
      this.filters.search = "";
      this.updateWorkloads();
    }
  },

  created() {
    this.getTimePeriods().then(() => {
      this.getFiscalYearTimePeriod().then(() => {
        this.filters.timePeriodId = this.fiscalYearTimePeriod.timePeriodId;
        this.updateWorkloads();
      });
    });

    this.getWorkloadTypeDefinitions();
  }
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}
</style>
